<div class="container">
  <div class="box-form"></div>
  <div class="row-3"></div>
</div>
